import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface IMySongsFiltersGenre {
  // Genre id
  id: number;
  name: string;
}

export interface IMySongsFiltersDifficultyCategory {
  // difficulty Category id
  id: number;
  name: string;
}

export interface IMySongsFiltersDifficultySubcategory {
  // difficulty Subcategory id
  id: number;
  name: string;
}

export interface IMySongsFiltersDifficulty {
  // difficulty id
  id: number;
  categoryId: number;
  subcategoryId: number;
}
export interface IMySongsFiltersArrangementType {
  // arrangement type id
  id: number;
  name: string;
}

interface IMySongsFilters {
  loadedAt?: number;
  genres?: ReduxStoreValuesIndexedById<IMySongsFiltersGenre>;
  difficulties?: IMySongsFiltersDifficulty[];
  difficultyCategories?: ReduxStoreValuesIndexedById<IMySongsFiltersDifficultyCategory>;
  difficultySubcategories?: ReduxStoreValuesIndexedById<IMySongsFiltersDifficultySubcategory>;
  arrangementTypes?: ReduxStoreValuesIndexedById<IMySongsFiltersArrangementType>;
}

export interface IMySongsFiltersStore extends IMySongsFilters {}

export interface IMySongsFiltersLoadPayload {
  genres?: IMySongsFiltersGenre[];
  difficulties?: IMySongsFiltersDifficulty[];
  difficultyCategories?: IMySongsFiltersDifficultyCategory[];
  difficultySubcategories?: IMySongsFiltersDifficultySubcategory[];
  arrangementTypes?: IMySongsFiltersArrangementType[];
}


const transformToIdIndexedStore = <StoreObject extends {id: number}>(input?: StoreObject[]): PropIndexedStore<StoreObject, 'id'> | undefined  => {
  if (typeof input === "undefined"){
    // not defined, nothing to do
    // return undefined input
    return input;
  }

  const indexedStore: ReduxStoreValuesIndexedById<StoreObject> = {
    ids: [],
    byId: {},
  };
  input.forEach((inputItem) => {
    const keyValue: number = inputItem.id;
    indexedStore.ids.push(keyValue)
    indexedStore.byId[keyValue] = inputItem;
  });
  return indexedStore;
}

const transformPayloadDataForStore = (payload: IMySongsFiltersLoadPayload): IMySongsFiltersStore => {
  return {
    genres: transformToIdIndexedStore<IMySongsFiltersGenre>(payload.genres),
    difficultyCategories: transformToIdIndexedStore<IMySongsFiltersDifficultyCategory>(payload.difficultyCategories),
    difficultySubcategories: transformToIdIndexedStore<IMySongsFiltersDifficultySubcategory>(payload.difficultySubcategories),
    difficulties: payload.difficulties,
    arrangementTypes: transformToIdIndexedStore<IMySongsFiltersArrangementType>(payload.arrangementTypes),
  }
};

const initialState: IMySongsFiltersStore = {};

/**
 * This slice represents the 2nd of 2 parts of an API response. The loadedAt property is duplicated in each slice.
 * @see IMySongsLibraryResponse
 */
export const mySongsFiltersSlice = createSlice({
  name: `mySongsFilters`,
  initialState,

  reducers: (create) => ({
    loadMySongsFilters: create.reducer(
      (_store: IMySongsFiltersStore, action: PayloadAction<IMySongsFiltersLoadPayload>) => {
        return {
          loadedAt: Date.now(),
          ...transformPayloadDataForStore(action.payload),
        };
      }
    ),

    clearMySongsFilters: create.reducer((_store: IMySongsFiltersStore) => {
      return {
        ...initialState,
        loadedAt: 0,
      };
    })
  }),
  selectors: {
    loadedAtSelector: (store: IMySongsFiltersStore) => store.loadedAt,
    genresSelector: (store: IMySongsFiltersStore) => store.genres,
    difficultyCategoriesSelector: (store: IMySongsFiltersStore) => store.difficultyCategories,
    difficultySubcategoriesSelector: (store: IMySongsFiltersStore) => store.difficultySubcategories,
    difficultiesSelector: (store: IMySongsFiltersStore) => store.difficulties,
    arrangementTypesSelector: (store: IMySongsFiltersStore) => store.arrangementTypes,
  }
});

export const mySongsFiltersReducer = mySongsFiltersSlice.reducer;

